import { FETCH_PROFILE } from './constants'

export const fetchProfile = () => ({
  type: FETCH_PROFILE,
  payload: {
    request: {
      method: 'get',
      url: '/profile'
    }
  }
})
